import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Memory Game Layout
 * @description Nested stack navigator for memory game screens
 */
export default function MemoryLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[sessionId]" />
    </Stack>
  );
}

